// Component
const DogPurchaseTransactionSuccess = () => import(/* webpackPrefetch: true, webpackChunkName: "dog-purchase-transaction-success" */ '@/app/views/client-view/dog-purchase-public-page/components/dog-purchase-transaction-success/dog-purchase-transaction-success.vue');
const ClientHeader = () => import(/* webpackPrefetch: true, webpackChunkName: "client-header" */ '@/app/views/client-view/_shared/client-header/client-header.vue');
const TheFooter = () => import(/* webpackPrefetch: true, webpackChunkName: "the-footer" */ '@/app/views/main-view/_shared/the-footer/the-footer.vue');

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

// Services
import PetOrderService from "@/app/services/main/pet-order/pet-order-service";

export default {
    name: 'DogPurchasePublicSuccess',
    components: { 
        DogPurchaseTransactionSuccess,
        ClientHeader,
        TheFooter
    },
    directive: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
        return {
			dogPurchaseDetails: null,
            isAPILoading: true
        }
    },
    computed: {
        isNativeApp() {
			return this.$store.getters.getIsNativeApp;
		}
    },
    watch: {},
    created() {
        const { referenceId, token } = this.$route.query;
        this.getDogPurchaseDetails(referenceId, token);
    },
    methods: {
        getDogPurchaseDetails(referenceId, token) {
            this.isAPILoading = true;
			PetOrderService.getDogPurchase({f_referenceId: referenceId, f_token: token})
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.dogPurchaseDetails = res.data;
					}
				})
                .finally(()=> {
                    this.isAPILoading = false;
                })
		}
    },
    // third party libraries
}